import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UATConstants } from 'src/Common/Models/UATConstants';
import {
  MANAGE_ACTION_API_CONSTANTS,
  MANAGE_ACTION_CONSTANTS,
} from 'src/manageAction/utils/manageActionConstants';
import { IMSXInfoResponse } from 'src/manageAction/interfaces/SGCI';

export const commonApi = createApi({
  reducerPath: 'commonApi',
  baseQuery: fetchBaseQuery({
    baseUrl: UATConstants.CommonServicesWebApiUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_API);
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['getMSXDataByMsSalesId'],
  endpoints: (builder) => ({
    getMSXDataByMsSalesId: builder.query<IMSXInfoResponse, string>({
      query: (mssalesid) => ({
        method: 'GET',
        url: `${MANAGE_ACTION_API_CONSTANTS.GetMSXInfoByMSSalesID}/${mssalesid}`,
      }),
      providesTags: ['getMSXDataByMsSalesId'],
    }),
  }),
});

export const { useGetMSXDataByMsSalesIdQuery } = commonApi;